import React, { useEffect, useState } from 'react';
import { InterfaceRoutes } from '../../interfaces/interfaceRoutes';
import './home.css';
import { getFgHero, getFgInicios, STRAPI_BASE_URL } from '../../config/services/strapi/home';
import TextSkeleton from '../../components/Skeleton/TextSkeleton';
import ImageSkeleton from '../../components/Skeleton/ImageSkeleton';

interface InicioCard {
  id?: number;
  image: string;
  number: string;
  descripcion: any;
}

const renderDescripcion = (descripcion: any, keyPrefix: string) => {
  if (Array.isArray(descripcion)) {
    return descripcion
      .map((block: any, index: number) => {
        const text = block?.children?.map((c: any) => c?.text || '').join('');

        if (!text) {
          return null;
        }

        if (index === 0) {
          return (
            <h3 key={`${keyPrefix}-descripcion-${index}`} className="desc-title">
              {text}
            </h3>
          );
        }

        return <p key={`${keyPrefix}-descripcion-${index}`}>{text}</p>;
      })
      .filter(Boolean);
  }

  if (typeof descripcion === 'string' && descripcion.trim()) {
    return <p>{descripcion}</p>;
  }

  return null;
};

const getMediaUrl = (media: any) => {
  const rawUrl = media?.url || media?.data?.attributes?.url;

  if (!rawUrl || typeof rawUrl !== 'string') {
    return '';
  }

  if (rawUrl.startsWith('http://') || rawUrl.startsWith('https://')) {
    return rawUrl;
  }

  return `${STRAPI_BASE_URL}${rawUrl}`;
};

const Home = (_props: InterfaceRoutes) => {
  const [heroImage, setHeroImage] = useState<string>('');
  const [stats, setStats] = useState<InicioCard[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const [heroData, iniciosData] = await Promise.all([getFgHero(), getFgInicios()]);

        const heroUrl = getMediaUrl(heroData?.hero || heroData?.attributes?.hero);
        if (heroUrl) {
          setHeroImage(heroUrl);
        }

        if (Array.isArray(iniciosData) && iniciosData.length > 0) {
          const formattedStats = iniciosData.map((item: any) => {
            const attrs = item?.attributes || item;
            return {
              id: item?.id,
              image: getMediaUrl(attrs?.portada),
              number: attrs?.cantidad?.toString() || '',
              descripcion: attrs?.descripcion || '',
            };
          }).filter((item: InicioCard) => item.image || item.number || item.descripcion);

          setStats(formattedStats);
        }
      } catch (error) {
        console.error('Error cargando home desde Strapi:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchHomeData();
  }, []);

  return (
    <div id="main-content" className="home-page">
      {loading && (
        <div id="hero-qs-wrapper">
          <ImageSkeleton className="home-hero-skeleton" />
        </div>
      )}

      {!loading && heroImage && (
        <div id="hero-qs-wrapper">
          <div id="hero-qs-image">
            <img
              src={heroImage}
              alt="Hero Fundacion Gasco"
            />
          </div>
        </div>
      )}

      <section id="welcome">
        <h2>
          Desde el año 2001 aportamos al desarrollo educativo y artístico a través de nuestros programas
        </h2>

        <div className="rows-wrapper">
          {loading && (
            <>
              <div className="row">
                <ImageSkeleton className="home-card-image-skeleton" />
                <div className="stat">
                  <TextSkeleton className="home-card-text-skeleton" />
                </div>
              </div>
              <div className="row">
                <ImageSkeleton className="home-card-image-skeleton" />
                <div className="stat">
                  <TextSkeleton className="home-card-text-skeleton" />
                </div>
              </div>
              <div className="row">
                <ImageSkeleton className="home-card-image-skeleton" />
                <div className="stat">
                  <TextSkeleton className="home-card-text-skeleton" />
                </div>
              </div>
            </>
          )}

          {stats.map((stat) => (
            <div className="row" key={stat.id || stat.number}>
              <figure>
                <img src={stat.image} alt={typeof stat.descripcion === 'string' ? stat.descripcion : stat.number} />
              </figure>
              <div className="stat">
                <p className="num">{stat.number}</p>
                <div className="desc">{renderDescripcion(stat.descripcion, stat.id?.toString() || stat.number)}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="outro" />
      </section>
    </div>
  );
};

export default Home;
